/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { environment } from '@environments/environment';
import {
  RoutesActivationModel,
  AppConfigModel,
  StepsConfigModel
} from '@models/.';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor(
    @Inject('APP_CONFIG') private appConfig: AppConfigModel,
    @Inject('STEPS_CONFIG') private stepsConfig: StepsConfigModel,
    @Inject('ROUTES_ACTIVATION')
    private routesActivation: RoutesActivationModel
  ) {}

  /**
   * restituisce configurazione app
   */
  getConfig(): AppConfigModel {
    return (
      (this.appConfig && { ...this.appConfig }) || {
        theme: {},
        generic: {},
        security: {},
        wizard: {},
        survey: {},
        form: {},
        upload: {},
        labels: {},
        recognition: {},
        obligations: {},
        documentsRequest: {}
      }
    );
  }

  /**
   * restituisce configurazione step
   */
  getStepsConfig(): StepsConfigModel {
    return (this.stepsConfig && { ...this.stepsConfig }) || {};
  }

  /**
   * restituisce configurazione di attivazione delle rotte
   */
  getRoutesActivation(): RoutesActivationModel {
    return (this.routesActivation && { ...this.routesActivation }) || {};
  }

  /**
   * restituisce il numero di versione dell'app
   */
  getAppVersion(target: 'container' | 'core' = 'container'): string {
    const versions = {
      // eslint-disable-next-line @typescript-eslint/dot-notation
      container: window['APP_CONTAINER_VERSION'],
      // eslint-disable-next-line @typescript-eslint/dot-notation
      core: window['APP_CORE_VERSION']
    };

    if (!!versions[target]) {
      return versions[target];
    } else {
      return '';
    }
  }

  /**
   * restituisce l'ambiente in cui è in esecuzione l'app
   */
  getHostEnv(): 'localhost' | 'develop' {
    const host = location.host;

    if (host.indexOf('localhost') > -1) {
      return 'localhost';
    } else if (host.indexOf('sviluppo')) {
      return 'develop';
    } else {
      return null;
    }
  }

  /**
   * stabilisce se un driver di configurazione è attivo
   */
  isDriverEnabled(domainKey: string, driverKey: string): boolean {
    const config = this.getConfig();

    return (!!config[domainKey] && !!config[domainKey][driverKey]) || false;
  }

  /**
   * determina se è attiva la dev mode
   */
  isDevMode(): boolean {
    return !!environment.devMode;
  }

  /**
   * determina se la demo è attiva
   */
  isDemoActive(): boolean {
    return this.isDevMode() && !!localStorage.getItem('useDemo');
  }

  /**
   * determina se il mock è attivo
   */
  isMockActive(): boolean {
    return (
      !this.isDemoActive() &&
      this.isDevMode() &&
      !!localStorage.getItem('useMock')
    );
  }
}
